<template>
  <!-- <div class="fit column bg-secondary overflow-hidden"> -->
  <Layout>
    <template #header> 底盘协同控制 </template>

    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div class="col-4 full-height">
          <q-card bordered class="full-height column">
            <q-card-section class="column justify-around full-height">
              <div
                class="q-gutter-xs row justify-center items-center"
                style="font-weight: bold"
              >
                <template v-for="(selection, index) in selections" :key="index">
                  <q-chip
                    size="17px"
                    class="select-chip"
                    square
                    :selected="selection.value"
                    :icon-selected="selection.icon"
                    @update:selected="
                      (value: any) => handleSelectionChange(selection.name, value)
                    "
                    :icon="selection.icon"
                    :label="selection.label"
                    :disable="selectionsDisable[selection.name]"
                  >
                  </q-chip>
                </template>
              </div>
              <div v-for="slider in sliders" :key="slider.id">
                <div class="text-h6" style="font-weight: bold">
                  {{ slider.label }}
                </div>
                <div
                  class="row justify-between relative-position slider-color"
                  style="height: 24px; margin-top: 10px"
                >
                  <span
                    class="absolute"
                    style="left: 0px"
                    @click="handleSliderChange(slider.id, slider.min)"
                    >{{ slider.minLabel }}</span
                  >
                  <span
                    class="absolute-center"
                    style="min-height: 25px; min-width: 25px"
                    @click="handleSliderChange(slider.id, slider.minddle)"
                    >{{ slider.minddleLabel || " " }}</span
                  >
                  <span
                    class="absolute"
                    style="right: 0px"
                    @click="handleSliderChange(slider.id, slider.max)"
                    >{{ slider.maxLabel }}</span
                  >
                </div>
                <!--  switch-label-side  -->
                <q-slider
                  track-size="8px"
                  thumb-size="28px"
                  :model-value="slider.model"
                  color="green-6"
                  markers
                  :label="!slider.notShowLabel"
                  :label-always="!slider.notShowLabel"
                  :min="slider.min"
                  :max="slider.max"
                  :step="slider.step"
                  @update:model-value="
                    (value: any) => handleSliderChange(slider.id, value)
                  "
                />
              </div>
              <div
                class="row justify-between items-center text-grey-9 q-pl-md q-pr-md"
              >
                <q-btn
                  :class="`relative flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500`"
                  round
                  @click="handleReset"
                >
                  <q-icon name="refresh" size="lg" class="text-white" />
                </q-btn>

                <!-- <button
                  @click="handleReset"
                  :class="`relative flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500`"
                >
                  <q-icon name="refresh" size="lg" class="text-white" />
                </button> -->

                <PlayPauseButton
                  :initial-state="playStatus === 'play'"
                  @toggle="handlePlayStatusChange"
                />

                <!-- <DebounceBtn
                  size="16px"
                  round
                  :class="playStatus === 'play' ? 'btn-active' : 'btn-style'"
                  :color="playStatus === 'play' ? 'red' : 'green-6'"
                  :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
                  @click="handlePlayStatusChange"
                /> -->
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-8 full-height">
          <q-card bordered class="full-height column overflow-hidden">
            <q-card-section class="q-pa-none relative-position" style="flex: 1">
              <DebounceBtn
                class="absolute"
                style="
                  z-index: 2;
                  left: 50px;
                  top: 26px;
                  width: 50px;
                  font-size: 12px;
                "
                color="blue-grey-13"
                :icon="'img:' + 切换"
                @click="handleToggleChart(1)"
              />
              <DomainControlCharts
                ref="chartACU"
                v-if="slide2 === 1"
                key="1"
                :max="540"
                :min="-540"
                :start="200"
                :end="-200"
                :x-axis-length="LENGTH"
                :series="optionsACU"
                :tooltip="tooltipACU"
                :legend="legendACU"
                :yAxis="yAxis"
                :grid="gridACU"
                :dataZoom="dataZoom"
                :need-x-data-zoom="true"
                :show-x-axis-label="false"
                @data-zoom="handleDataZoom"
              />
              <DomainControlCharts
                ref="chartPinion"
                v-if="slide2 === 2"
                key="2"
                :max="540"
                :min="-540"
                :start="200"
                :end="-200"
                :legendTop="30"
                :x-axis-length="LENGTH_SECOND"
                :series="optionsPinion"
                :tooltip="tooltip"
                :grid="gridACU"
                :need-x-data-zoom="true"
                :show-x-axis-label="false"
                @data-zoom="handleDataZoom"
              />
            </q-card-section>

            <q-card-section
              class="row q-pa-none relative-position"
              style="flex: 1"
            >
              <DebounceBtn
                class="absolute"
                style="
                  z-index: 2;
                  left: 50px;
                  top: 30px;
                  width: 50px;
                  font-size: 12px;
                "
                color="blue-grey-13"
                :icon="'img:' + 切换"
                @click="handleToggleChart(2)"
              />
              <DomainControlCharts
                ref="chartAxleStAng"
                key="1"
                v-if="slide === 1"
                :max="60"
                :min="-60"
                :start="-30"
                :end="30"
                :x-axis-length="LENGTH"
                :series="optionsAxleStAng"
                :tooltip="tooltip"
                :legendTop="30"
                :need-x-data-zoom="true"
                :data-zomm-x-show="false"
                @data-zoom="handleDataZoom"
              />
              <DomainControlCharts
                ref="chartWhlBrkTqAct"
                key="2"
                v-if="slide === 2"
                :max="4000"
                :min="0"
                :start="1500"
                :end="0"
                :x-axis-length="LENGTH"
                :series="optionsWhlBrkTqAct"
                :tooltip="tooltip"
                :data-zomm-mirror-drag="false"
                :data-zomm-disabled-start="true"
                :legendTop="30"
                :need-x-data-zoom="true"
                :data-zomm-x-show="false"
                @data-zoom="handleDataZoom"
              />

              <DomainControlCharts
                ref="chartDeltaOff"
                key="3"
                v-if="slide === 3"
                :max="5"
                :min="-5"
                :start="1"
                :end="-1"
                :x-axis-length="LENGTH"
                :tooltip="tooltip"
                :series="optionsDeltaOff"
                :legendTop="30"
                :need-x-data-zoom="true"
                :data-zomm-x-show="false"
                @data-zoom="handleDataZoom"
              />
            </q-card-section>

            <!-- </div> -->
          </q-card>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import Layout from "./components/Layout.vue";
import Charts from "@/components/Charts";
import {
  generateMockICCNofifyData,
  NOTIFY,
} from "@/services/domainControl/icc";
import {
  decreasingSequence,
  decreasingSequenceSecond,
  getACUDataZoom,
  getACUGrid,
  getACULegend,
  getACUTooltip,
  getACUYaxis,
  getDefaultGrid,
  getDefaultSelections,
  getDefaultSeriesData,
  getDefaultSlider,
  getTooltip,
  LENGTH,
  LENGTH_SECOND,
  optionseries1,
  optionseries2,
  optionseries3,
  optionseries4,
  optionseries5,
  optionseries6,
  parseUITx_FrontVgrSw,
  PlayStatus,
  transformSeriesData,
} from "./helper/icc";
import { isWeb } from "@/utils/capacitor";
import { useDomainControlStore } from "@/stores/domainControl";
import { SERVICE } from "@/services/domainControl/define";
import { signalTransformBool2Num, signalTransformNum2Bool } from "./helper";
import useInitialize from "@/composables/domainControl/useInitialize";
import { useQuasar } from "quasar";
import { toFixed } from "@/utils/math";
import { debounce } from "lodash-es";
import DomainControlCharts from "@/components/DomainControlCharts";
import DebounceBtn from "@/components/DebounceBtn";
import 切换 from "@/assets/img/切换.png";
import PlayPauseButton from "@/components/PlayPauseButton.vue";
const $q = useQuasar();
const tooltip = getTooltip();
const tooltipACU = getACUTooltip();

const dataZoom = getACUDataZoom();
const gridACU = getACUGrid();
const grid = getDefaultGrid();
// const gridRA = { ...getACUGrid(), top: 10 };
const legendACU = getACULegend($q);
const yAxis = getACUYaxis($q);

const domainControlStore = useDomainControlStore();
// const loading = ref([] as boolean[]);
const playStatus = ref<PlayStatus>("play");
const seriesData = ref(getDefaultSeriesData());
const selections = ref(getDefaultSelections());
const selectionsDisable = {
  brake_by_wire: true,
  UITx_ActuatorEna_SbW: false,
  UITx_ActuatorEna_Rws: false,
  UITx_ActuatorEna_FAS: true,
  UITx_ActuatorEna_DTD: true,
} as Dictionary<boolean>;
const sliders = ref(getDefaultSlider());
const optionsACU = ref(optionseries1());
const optionsDeltaOff = ref(optionseries2());
const optionsWhlBrkTqAct = ref(optionseries3());
const optionsAxleStAng = ref(optionseries5());
const optionsPinion = ref(optionseries6());

const chartACU = ref();
const chartDeltaOff = ref();
const chartWhlBrkTqAct = ref();
const chartAxleStAng = ref();
const chartPinion = ref();

const slide = ref(1);
const slide2 = ref(1);
const xDataZoomData = ref({
  start: 0,
  end: 100,
});

const handleNotify = (data: DomianControl.ICCNotifyData) => {
  if (playStatus.value !== "play") return;
  parseSeriesData(data);
};

const parseSeriesData = (data: DomianControl.ICCNotifyData) => {
  data = transformSeriesData(data);
  const res = Object.keys(data).reduce((per, key) => {
    const value = data[key];
    const curList = seriesData.value[key];
    //  8 second situation
    if (
      ["UIRx_PinionTarVgr", "UIRx_PinionAct", "UIRx_SBW_HWAAng_2"].includes(key)
    ) {
      if (curList.length >= decreasingSequenceSecond.length) curList.shift();
    } else {
      if (curList.length >= decreasingSequence.length) curList.shift();
    }
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.ICCSeriesData);
  seriesData.value = res;
};

const parseOutputValue = (value: DomianControl.OutputValue) => {
  parseSliderValue(value);
  parseSelectionValue(value);
};

const { startNotifications, stopNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

const setOptions = () => {
  const {
    UIRx_SBW_HWAAng,
    UIRx_ACUYawRate,
    UIRx_WhlBrkTqAct_FL_BCh1,
    UIRx_WhlBrkTqAct_FR_BCh1,
    UIRx_WhlBrkTqAct_RL_BCh1,
    UIRx_WhlBrkTqAct_RR_BCh1,
    UIRx_DeltaOff_FA,
    UIRx_DeltaOff_RA,
    UIRx_AxleStAng_FA = [],
    UIRx_AxleStAng_RA = [],
    UIRx_FrontGearRto,
    UIRx_RearGearRto,
    UIRx_SBW_HWAAng_2,
    UIRx_PinionTarVgr,
    UIRx_PinionAct,
  } = seriesData.value;

  (optionsACU.value as any)[0].data = UIRx_SBW_HWAAng;
  (optionsACU.value as any)[1].data = UIRx_ACUYawRate;
  (optionsACU.value as any)[2].data = UIRx_FrontGearRto;
  (optionsACU.value as any)[3].data = UIRx_RearGearRto;

  // (optionsRA.value as any)[0].data = UIRx_alphaRA;
  (optionsAxleStAng.value as any)[0].data = UIRx_AxleStAng_FA;
  (optionsAxleStAng.value as any)[1].data = UIRx_AxleStAng_RA;

  (optionsWhlBrkTqAct.value as any)[0].data = UIRx_WhlBrkTqAct_FL_BCh1;
  (optionsWhlBrkTqAct.value as any)[1].data = UIRx_WhlBrkTqAct_FR_BCh1;
  (optionsWhlBrkTqAct.value as any)[2].data = UIRx_WhlBrkTqAct_RL_BCh1;
  (optionsWhlBrkTqAct.value as any)[3].data = UIRx_WhlBrkTqAct_RR_BCh1;

  (optionsDeltaOff.value as any)[0].data = UIRx_DeltaOff_FA;
  (optionsDeltaOff.value as any)[1].data = UIRx_DeltaOff_RA;

  (optionsPinion.value as any)[0].data = UIRx_SBW_HWAAng_2;
  (optionsPinion.value as any)[1].data = UIRx_PinionTarVgr;
  (optionsPinion.value as any)[2].data = UIRx_PinionAct;
};
setOptions();

const handlePlayStatusChange = debounce(async () => {
  const value = playStatus.value === "play" ? "pause" : "play";
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    setOptions();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
    // startNotifications();
  }
  playStatus.value = value;
}, 200);
const handleReset = () => {
  // seriesData.value = getDefaultSeriesData();
  seriesData.value.UIRx_ACULatAcc = [];
  seriesData.value.UIRx_ACULongdAcc = [];
  selections.value = getDefaultSelections();
  sliders.value = getDefaultSlider();
  domainControlStore.writeOutputValue({
    UITx_CoStab: 0,
    UITx_CoStaticChar: 0,
    UITx_CoDynChar: 0,
    UITx_ActuatorEna_SbW: 0,
    UITx_ActuatorEna_Rws: 0,
    UITx_ActuatorEna_FAS: 0,
    UITx_ActuatorEna_DTD: 0,
    UITx_FrontVgrSw: 2,
  });
};

// const resetACC = debounce(() => {
//   seriesData.value.UIRx_ACULatAcc = [];
//   seriesData.value.UIRx_ACULongdAcc = [];
// }, 500);

const parseSliderValue = async (outputValue: DomianControl.OutputValue) => {
  ["UITx_CoStab", "UITx_CoStaticChar", "UITx_CoDynChar", "UITx_FrontVgrSw"].map(
    (key) => {
      let value = outputValue[key];
      if (key === "UITx_FrontVgrSw") value = parseUITx_FrontVgrSw(value);
      const slider = sliders.value.find((s) => s.id === key);
      slider && (slider.model = value);
    }
  );
};
const parseSelectionValue = async (outputValue: DomianControl.OutputValue) => {
  const res = getDefaultSelections();
  [
    "UITx_ActuatorEna_SbW",
    "UITx_ActuatorEna_Rws",
    "UITx_ActuatorEna_FAS",
    "UITx_ActuatorEna_DTD",
  ].map((key) => {
    const value = signalTransformNum2Bool(outputValue[key]);
    const item = res.find((item) => item.name === key);
    if (item) item.value = value;
  });
  selections.value = res;
};

const handleSliderChange = (type: string, value: any) => {
  if (value === null) return;
  sliders.value.map((item) => {
    if (item.id === type) {
      item.model = value;
    }
  });
  if (type === "UITx_FrontVgrSw") {
    value = parseUITx_FrontVgrSw(value);
  }
  // value = signalTransform1.build(value);
  domainControlStore.writeOutputValue({
    [type]: value,
  });
};
const handleSelectionChange = (type: string, value: boolean) => {
  const data = signalTransformBool2Num(value);
  domainControlStore.writeOutputValue({
    [type]: data,
  });
  selections.value.forEach((item) => {
    if (item.name === type) item.value = value;
  });
};

const handleToggleChart = (value: any) => {
  if (value === 1) {
    slide2.value = slide2.value === 1 ? 2 : 1;
  } else {
    slide.value + 1 > 3 ? (slide.value = 1) : (slide.value += 1);
  }
  setTimeout(() => {
    setAllXDataZoom(xDataZoomData.value.end, xDataZoomData.value.start);
  }, 0);
};
const handleDataZoom = (value: any) => {
  const { end, start, dataZoomId } = value;
  if (dataZoomId === "dataZoomX") {
    setAllXDataZoom(end, start);
  }
};

const setAllXDataZoom = (end: number, start: number) => {
  const dataZoom = [{}, { end, start }];
  const option = { dataZoom };
  chartACU.value?.echarts?.setOption(option);
  chartDeltaOff.value?.echarts?.setOption(option);
  chartWhlBrkTqAct.value?.echarts?.setOption(option);
  chartAxleStAng.value?.echarts?.setOption(option);
  chartPinion.value?.echarts?.setOption(option);
  xDataZoomData.value = { end, start };
};

onMounted(() => {
  // setInterval(() => {
  //   handleNotify(generateMockICCNofifyData());
  // }, 50);
});
</script>

<style scoped lang="scss">
.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  // box-shadow: 0 0 10px white, 0 0 20px white, 0 0 40px white;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
</style>
